import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalConstants } from './global-variables';

export type dataLayerItem = {
	'event': any,
	'EventCategory': any,
	'EventAction'?: any,
	'EventLabel'?: any,
	'url'?: any,
	[x:string]:any
}
export type dataLayerUserItem = {
	"event": any,
	"UserID"?: any,
	"usertype"?: any,
	[x:string]:any
}
interface DigitalData {
  eventName: string;
}
declare const _satellite: any;
@Injectable({ providedIn: 'root' })
export class AubGTMTrackingService {

	constructor() {
	}

	aubts_gtm_login_session_closed() {
		this.pushToDataLayer({
			'event': 'offers_Login-session closed',
			'EventCategory': 'Offers Login',
			'EventAction': 'Login Status',
			'EventLabel': 'Session Closed',
			'url': '/vpv/offers/login/login-status/session-closed'
		});

	}

	aubts_gtm_Login_loggedin() {
		this.pushToDataLayer({
			'event': 'offers_Login-Loggedin',
			'EventCategory': 'Offers Login',
			'EventAction': 'Login Status',
			'EventLabel': 'Logged-in',
			'url': '/vpv/offers/login/login-status/logged-in'
		});
	}
	aubts_login_modal_open() {
		this.updateWindowAdobeEvent('login');
		_satellite?.track('trackEvent');
	}

	aubts_gtm_login_session_closed_tryagain() {
		this.pushToDataLayer({
			'event': 'offers_Login_Session closed-try again',
			'EventCategory': 'Offers Login',
			'EventAction': 'Try Again',
			'EventLabel': 'Session Closed',
			'url': '/vpv/offers/login/session-closed/try-again'
		});

	}

	aubts_gtm_offers_Login_first_registration() {
		this.pushToDataLayer({
			'event': 'offers_Login-first-registration',
			'EventCategory': 'Offers Login',
			'EventAction': 'Registration',
			'EventLabel': '',
			'url': '/vpv/offers/login/registration/new'
		});
	}

	public aubts_gtm_claim(event: 'claim' | 'add-to-cart', additionalData: Record<string, unknown>): void {
		this.pushToDataLayer({
			event: event,
			eventCategory: 'button',
			eventAction: 'click',
			eventLabel: event,
			...additionalData
		});
		this.updateWindowAdobeEvent('Claim offer');
		_satellite?.track('trackEvent');
	}

	pushToDataLayer(dataLayerObject: dataLayerItem | dataLayerUserItem): void {
		if (window && window.dataLayer) {
			window.dataLayer.push(dataLayerObject);
		}
	}

	private updateWindowAdobeEvent(eventName: string){
		if (window['digitalData']) {
			const digitalData: DigitalData = window['digitalData'];
			digitalData.eventName = eventName;
		}
	}

}
